// swAutoReload — 새 서비스 워커가 제어권을 가져오면 페이지를 1회 새로고침한다.
//
// 배경 (2026-10-03): registerType 'autoUpdate'는 새 SW를 skipWaiting+clientsClaim으로 즉시 활성화하지만,
// 새로고침 "그 순간"에는 이전 SW가 precache된 옛 index.html·JS를 내준다. 새 SW는 그 뒤 설치되므로
// 배포 후 새로고침 1회로는 옛 화면이 남고 2회째에야 새 버전이 보였다.
// → controllerchange(새 SW가 페이지를 장악) 시점에 한 번 reload 해서 새로고침 1회로 반영되게 한다.
//
// 안전장치:
// - 최초 설치(기존 controller 없음)에는 reload 하지 않는다.
// - 주기적 update 체크를 하지 않으므로 controllerchange는 사실상 페이지 로드 직후에만 발생 → 편집 중 reload 없음.
// - 무한 루프 방지: 페이지당 1회만.

interface SwContainerLike {
  controller: unknown;
  addEventListener: (type: 'controllerchange', cb: () => void) => void;
}

/**
 * controllerchange 리스너를 설치한다.
 * @returns 설치 여부 (서비스 워커 미지원 환경이면 false)
 */
export function installSwAutoReload(
  sw: SwContainerLike | undefined = typeof navigator !== 'undefined' ? navigator.serviceWorker : undefined,
  reload: () => void = () => window.location.reload(),
): boolean {
  if (!sw) return false;
  const hadController = Boolean(sw.controller);
  let reloaded = false;
  sw.addEventListener('controllerchange', () => {
    if (!hadController || reloaded) return;
    reloaded = true;
    reload();
  });
  return true;
}
